export default {
      id: "logo-mini-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#logo-mini",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./static/images/sprite-icons/logo-mini.svg
// module id = xhAB
// module chunks = 1